import "./App.css";
import Login from "./components/login";
import Signup from "./components/signup";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Routedetails from "./components/routedetails";
import Landing from "./components/landing";
import Homepage from "./components/homepage";
import Forgettenpassword from "./components/forgettenpassword";

import Userprofile from "./components/userprofile.js";
import React, { Component, useState, useEffect } from "react";
import Filterpage from "./components/filterpage";
import { getRoutes } from "./services/routeServices";
import Error from "./components/error";
import Denemealani from "./services/denemeAlani";

function App() {
  const [serviceData, setServiceData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      await getRoutes().then((res) => {
        setServiceData(res);
        setTimeout(console.log(res), 5000);
      });
    };
    // call the function
    fetchData()
      // make sure to catch any error
      .catch(console.error);
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Signup />} />
          <Route path="/forgetpass" element={<Forgettenpassword />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/userprofile" element={<Userprofile />} />
          <Route
            path="/routedetails"
            element={<Routedetails data={serviceData} />}
          />
          <Route path="/filterroute" element={<Filterpage />} />
          <Route path="*" element={<Error />} />
        </Routes>
      </Router>
    </>
  );
}

export default App;
